import React from "react";

function DrugTestLog() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden; /* Hide all elements on the page by default */
            }
            #DrugTestLogForm, #DrugTestLogForm * {
              visibility: visible; /* Make only the form and its children visible */
              color: black !important; /* Ensure text is black for printing */
            }
            #DrugTestLogForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            /* Hide the print button when printing */
            .print-button {
              display: none;
            }
            /* Ensure input fields are visible and readable when printed */
            input, textarea {
                border: 1px solid #000;
            }
          }
        `}
      </style>
      <div id="DrugTestLogForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Random Drug & Alcohol Test Log</h3>

        <form>
          {/* Test Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testDate">
              Test Date:
            </label>
            <input
              type="date"
              id="testDate"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Test Time */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testTime">
              Test Time:
            </label>
            <input
              type="time"
              id="testTime"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Tested By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testedBy">
              Tested By (Name):
            </label>
            <input
              type="text"
              id="testedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name of tester"
            />
          </div>

          {/* Test Result */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700">Test Result:</label>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Negative</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Positive</span>
              </label>
            </div>
          </div>

          {/* Tested Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testedDriverName">
              Tested Driver Name:
            </label>
            <input
              type="text"
              id="testedDriverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Tested Driver Licence No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testedDriverLicenceNo">
              Tested Driver Licence No.:
            </label>
            <input
              type="text"
              id="testedDriverLicenceNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver licence number"
            />
          </div>

          {/* Tested Driver CPC No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testedDriverCPCNo">
              Tested Driver CPC No.:
            </label>
            <input
              type="text"
              id="testedDriverCPCNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver CPC number"
            />
          </div>

          {/* Tested Driver Tachograph Card No. */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="testedDriverTachographCardNo">
              Tested Driver Tachograph Card No.:
            </label>
            <input
              type="text"
              id="testedDriverTachographCardNo"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter tachograph card number"
            />
          </div>

          {/* Manager Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignature">
              Signature of Manager:
            </label>
            <input
              type="text"
              id="managerSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Manager's signature"
            />
          </div>

          {/* Witness Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="witnessSignature">
              Signature of Witness:
            </label>
            <input
              type="text"
              id="witnessSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Witness's signature"
            />
          </div>

          {/* Driver Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="driverSignature">
              Signature of Driver:
            </label>
            <input
              type="text"
              id="driverSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Driver's signature"
            />
          </div>

          {/* Director Signature */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="directorSignature">
              Director Signature:
            </label>
            <input
              type="text"
              id="directorSignature"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Director's signature"
            />
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any follow-up actions required, such as further testing or disciplinary procedures"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-full md:w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors shadow-lg print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default DrugTestLog;
